import React from 'react';
import { Box, Typography } from '@mui/material';

const VoteInfo = ({ voteType, recommendation, comment, functionName, showRecommendation,isVotingPage,region }) => {
  return (
    <Box display="flex" gap={3}>
      <Box display="flex" flexDirection="column" width={125}>
        <Typography variant="body2" color="text.secondary">
          Vote:
        </Typography>
        <Typography variant="body2" color="text.secondary" mt={2}>
          Comment:
        </Typography>
        {functionName && <Typography variant="body2" color="text.secondary" mt={isVotingPage?7:2}>
          Function:
        </Typography> }
        {region && <Typography variant="body2" color="text.secondary" mt={2}>
          Region:
        </Typography>}
        {recommendation && <Typography variant="body2" color="text.secondary" mt={2}>
          Recommendation:
        </Typography>}
        
      </Box>
      <Box display="flex" flexDirection="column" flexGrow={1}>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ wordBreak: 'break-word', minHeight: '20px' }}>
          {voteType || '--'}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          mt={2}
          sx={{ wordBreak: 'break-word', minHeight: '20px' }}>
          {comment || '--'}
        </Typography>
        { functionName && <Typography
          variant="body2"
          color="text.secondary"
          mt={isVotingPage?7:2}
          sx={{ wordBreak: 'break-word', minHeight: '20px' }}>
          {functionName || '--'}
        </Typography>
        }
        {region && <Typography
          variant="body2"
          color="text.secondary"
          mt={2}
          sx={{ wordBreak: 'break-word', minHeight: '20px' }}>
          {region || '--'}
        </Typography>}
        {recommendation && <Typography
          variant="body2"
          color="text.secondary"
          mt={2}
          sx={{ wordBreak: 'break-word', minHeight: '20px' }}>
          {recommendation || '--'}
        </Typography>}
        
      </Box>
    </Box>
  );
};

export default VoteInfo;
